export enum DiscrepancyStatus {
    DISCREPANT = 'discrepant',
    CONGRUENT = 'congruent',
    DISCOVERED = 'discovered',
    NOOP = 'no-op'
}